import {useIntl} from 'react-intl'

export function ReviewingState() {
  const intl = useIntl()

  return (
    <div className='gori-signature-reviewing text-center' role='status' aria-live='polite'>
      <img
        src='/media/gori/gori-signature/reload.svg'
        alt='Loading'
        className='gori-signature-reload-icon mb-4'
        aria-hidden='true'
      />
      <p className='fs-3 text-white'>{intl.formatMessage({id: 'GORI_SIGNATURE_REVIEWING'})}</p>
    </div>
  )
}
ReviewingState.displayName = 'ReviewingState'
